<template>
  <div class="row h-100 no-gutters">
    <div class="auth-form mx-auto my-auto col-md-5 col-lg-3">
      <div class="card">
        <div class="card-body">
          <h1 style="text-align: center">
            <img
              id="main-logo"
              class="d-inline-block align-top mr-1"
              style="max-width: 150px;"
              src="@/assets/images/headwear.jpg"
              alt="" />
          </h1>

          <h3 class="text-center mb-4">
            {{ $t('register.passwordResetRequest.title') }}
          </h3>

          <d-alert
            v-if="resetError"
            theme="danger"
            show>
            {{ $t('register.passwordResetRequest.error') }}
            <div
              v-if="errors.indexOf('email') > -1"
              v-text="'- ' + errorMessages['email']"></div>
          </d-alert>

          <d-alert
            v-if="resetSuccess"
            theme="success"
            show>
            {{ $t('register.passwordResetRequest.success') }}
          </d-alert>

          <form
            v-if="!resetSuccess"
            @submit="reset">
            <div class="form-group">
              <label>{{ $t('ui.emailAddress') }}</label>
              <d-input
                v-model="email"
                name="email"
                type="email"
                @input="clearError('email')"
                :class="{'is-invalid': errors.indexOf('email') > -1}" />
            </div>
            <button
              type="submit"
              class="btn btn-pill btn-accent d-table mx-auto"
              @click.prevent="reset"
              :disabled="submitting">
              <template v-if="!submitting">{{ $t('register.passwordResetRequest.resetLabel') }}</template>
              <template v-else>{{ $t('register.passwordResetRequest.resetInProgress') }}</template>
            </button>
          </form>
        </div>

        <div
          class="card-footer text-center"
          style="background: rgba(90, 97, 105, .06);">
          <a href="/logowanie">
            {{ $t('register.login') }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'PasswordResetRequest',
  data () {
    return {
      resetError: false,
      resetSuccess: false,
      submitting: false,
      email: '',
      errors: [],
      errorMessages: {}
    }
  },
  methods: {
    clearError (errorName) {
      this.errors = this.errors.filter(error => error !== errorName);
    },
    clearErrors () {
      this.resetError = false;
      Vue.set(this, 'errors', []);
      Vue.set(this, 'errorMessages', {});
    },
    reset () {
      this.clearErrors();
      this.submitting = true;
      this.$http.post('/customer-panel/auth/customer-panel/email?lang=' + this.$i18n.locale, {
        email: this.email
      }).then((response) => {
        this.submitting = false;

        if (
          response.data &&
          response.data.success
        ) {
          this.resetSuccess = true;
        } else {
          this.resetError = true;
        }
      }).catch((error) => {
        console.log(error);
        this.submitting = false;
        this.resetError = true;

        if (error.response && error.response.data && error.response.data.errors) {
          Vue.set(this, 'errors', Object.keys(error.response.data.errors));

          for (let i = 0; i < this.errors.length; i++) {
            this.errorMessages[this.errors[i]] = error.response.data.errors[this.errors[i]].join(' ');
          }
        }
      });
    }
  }
}
</script>

<style scoped>

</style>
